import React, { useEffect, useState } from "react";
import DatePicker from "react-date-picker";
import { useDispatch } from "react-redux";
import { Grid } from "semantic-ui-react";
import AdvocatesDropdown from "../../components/athletes/AdvocatesDropdown";
import PositionList from "../../components/athletes/PositionList";
import SportList from "../../components/athletes/SportList";
import { newSignupRequest } from "../../store/actions/newSignup";
import { emailRegex, phoneRegex } from "../../utils/regex";
const currentYear = Number(new Date().getFullYear());

const EditUserDetails = (props) => {
  const [dob, setDob] = useState(new Date());
  const [sport, setSport] = useState(null);
  const [gmail, setGmail] = useState(null);
  const [PEmail1, setPEmail1] = useState(null);
  const [PNum1, setPNum1] = useState(null);
  const [PNum2, setPNum2] = useState(null);
  const [PEmail2, setPEmail2] = useState(null);
  const [error, setError] = useState(null);
  const [travel, setTravel] = useState(null);
  const [classYear, setClassYear] = useState(null);
  const [PPosition, setPPosition] = useState(null);
  const [SPosition, setSPosition] = useState(null);
  const [resides, setResides] = useState(null);
  const [father, setFather] = useState(null);
  const [mother, setMother] = useState(null);
  const [advocate, setAdvocate] = useState(null);
  const [athleteNumber, setAthleteNumber] = useState(null);
  const [School, setSchool] = useState(null);
  const [Comment, setComment] = useState(null);
  const [fname, setFname] = useState(null);
  const [lname, setLname] = useState(null);
  const [ref, setRef] = useState(null);
  const dispatch = useDispatch();

  const handleOnChange = (name, value) => {
    switch (name) {
      case "hsgy":
        if (isNaN(value) || Number(value) < currentYear || value.length > 4) {
          setError(`Invalid year ${currentYear - 1}`);
          setClassYear(props.details.classYear);
        } else {
          setClassYear(Number(value));
          setError(null);
        }
        break;
      default: {
      }
    }
  };

  const handleSubmit = () => {
    const toFireStore = {
      id: props.details.id,
      dob,
      travelTeam: travel ? travel : props.details.travelTeam,
      sport: sport ? sport : props.details.sport,
      primaryPosition: PPosition ? PPosition : props.details.primaryPosition,
      secondaryPosition: SPosition
        ? SPosition
        : props.details.secondaryPosition,
      fname: fname ? fname : props.details.fname,
      lname: lname ? lname : props.details.lname,
      classYear: classYear ? classYear : props.details.classYear,
      resides: resides ? resides : props.details.className,
      gmail: gmail ? gmail : props.details.gmail,
      parentsEmail1: PEmail1 ? PEmail1 : props.details.parentsEmail1,
      parentsEmail2: PEmail2 ? PEmail2 : props.details.parentsEmail2,
      motherName: mother ? mother : props.details.motherName,
      fatherName: father ? father : props.details.fatherName,
      advocate: advocate ? advocate : props.details.advocate,
      parentsPhone1: PNum1 ? PNum1 : props.details.parentsPhone1,
      parentsPhone2: PNum2 ? PNum2 : props.details.parentsPhone2,
      athletesPhone: athleteNumber
        ? athleteNumber
        : props.details.athletesPhone,
      school: School ? School : props.details.school,
      comment: Comment,
      ref,
    };
    // props.handleSubmit(toFireStore)
    dispatch(newSignupRequest(toFireStore));
  };
  useEffect(() => {
    if (props.save && !props.edit) {
      handleSubmit();
      props.handleSaveOff();
    }
  }, [props.save, props.edit]);

  useEffect(() => {
    if (props.details && Object.keys(props.details).length > 0) {
      const details = props.details;
      details.dob && setDob(details.dob.toDate());
      details.travelTeam && setTravel(details.travelTeam);
      details.sport && setSport(details.sport);
      details.primaryPosition && setPPosition(details.primaryPosition);
      details.secondaryPosition && setSPosition(details.secondaryPosition);
      details.fname && setFname(details.fname);
      details.lname && setLname(details.lname);
      details.classYear && setClassYear(details.classYear);
      details.resides && setResides(details.resides);
      details.gmail && setGmail(details.gmail);
      details.parentsEmail1 && setPEmail1(details.parentsEmail1);
      details.parentsEmail2 && setPEmail2(details.parentsEmail2);
      details.motherName && setMother(details.motherName);
      details.fatherName && setFather(details.fatherName);
      details.advocate && setAdvocate(details.advocate);
      details.parentsPhone1 && setPNum1(details.parentsPhone1);
      details.parentsPhone2 && setPNum2(details.parentsPhone2);
      details.athletesPhone && setAthleteNumber(details.athletesPhone);
      details.school && setSchool(details.school);
      details.comment && setComment(details.comment);
      details.ref && setRef(details.ref);
    }
  }, [props.details]);

  return (
    <Grid divided="vertically">
      <Grid.Row stackable="true">
        <Grid.Column mobile={16} tablet={8} computer={8}>
          <div className="form-group ">
            <label htmlFor="tarvelteam">Travel Team</label>
            <input
              id="tarvelteam"
              type="text"
              autoComplete="off"
              disabled={!props.edit}
              placeholder="Texas"
              defaultValue={props.details.travelTeam}
              onChange={(e) => {
                setTravel(e.target.value);
              }}
            />
          </div>
        </Grid.Column>
        <Grid.Column mobile={16} tablet={8} computer={8}>
          <div className="form-group">
            <label htmlFor="dob">Date of Birth</label>
            <DatePicker
              id="sdate"
              className="cu-datepicker"
              value={dob}
              onChange={setDob}
              disabled={!props.edit}
              placeholderText="Select start date"
            />
          </div>
        </Grid.Column>
        <Grid.Column mobile={16} tablet={8} computer={8}>
          <div className="form-group">
            <label htmlFor="dob">Sport</label>
            <SportList
              name="sport"
              className="cu-form-groups-dropdown"
              placeholder={props.details.sport}
              onChange={(e, { value }) => setSport(value)}
              disabled={!props.edit}
            />
          </div>
        </Grid.Column>
        <Grid.Column mobile={16} tablet={8} computer={8}>
          <div className="form-group">
            <label htmlFor="dob">Primary Position</label>
            <PositionList
              className="cu-form-groups-dropdown"
              placeholder={props.details.primaryPosition}
              sport={sport}
              onChange={(e, { value }) => setPPosition(value)}
              disabled={!props.edit}
            />
          </div>
        </Grid.Column>
        <Grid.Column mobile={16} tablet={8} computer={8}>
          <div className="form-group">
            <label htmlFor="dob">Secondary Position</label>
            <PositionList
              className="cu-form-groups-dropdown"
              name="Secondary Position"
              placeholder={props.details.secondaryPosition}
              sport={sport}
              onChange={(e, { value }) => setSPosition(value)}
              disabled={!props.edit}
            />
          </div>
        </Grid.Column>
        <Grid.Column mobile={16} tablet={8} computer={8}>
          <div className="form-group">
            <label htmlFor="studentname">Student Athlete First Name</label>
            <input
              id="studentfname"
              type="text"
              autoComplete="off"
              disabled={!props.edit}
              defaultValue={props.details.fname}
              onChange={(e) => setFname(e.target.value)}
            />
          </div>
        </Grid.Column>
        <Grid.Column mobile={16} tablet={8} computer={8}>
          <div className="form-group">
            <label htmlFor="studentname">Student Athlete Last Name</label>
            <input
              id="studentlname"
              type="text"
              autoComplete="off"
              disabled={!props.edit}
              placeholder="John Doe"
              defaultValue={props.details.lname}
              onChange={(e) => setLname(e.target.value)}
            />
          </div>
        </Grid.Column>
        <Grid.Column mobile={16} tablet={8} computer={8}>
          <div className="form-group">
            <label htmlFor="hsgy">High School Graduation Year </label>
            <input
              name="hsgy"
              id="hsgy"
              type="text"
              autoComplete="off"
              disabled={!props.edit}
              placeholder="2012"
              defaultValue={props.details.classYear}
              onChange={(e) => handleOnChange(e.target.name, e.target.value)}
            />
          </div>
        </Grid.Column>
        <Grid.Column mobile={16} tablet={8} computer={8}>
          <div className="form-group">
            <label htmlFor="resides">State Student Athlete resides </label>
            <input
              id="resides"
              type="text"
              autoComplete="off"
              disabled={!props.edit}
              defaultValue={props.details.resides}
              onChange={(e) => setResides(e.target.value)}
            />
          </div>
        </Grid.Column>
        <Grid.Column mobile={16} tablet={8} computer={8}>
          <div className="form-group">
            <label htmlFor="address">Student Athlete's Gmail</label>
            <input
              id="address"
              type="email"
              autoComplete="off"
              disabled={!props.edit}
              defaultValue={props.details.gmail}
              onChange={(e) => {
                e.target.value.endsWith("@gmail.com") &&
                  setGmail(e.target.value);
              }}
            />
          </div>
        </Grid.Column>
        <Grid.Column mobile={16} tablet={8} computer={8}>
          <div className="form-group">
            <label htmlFor="email1">Parent Email #1</label>
            <input
              id="email1"
              type="email"
              autoComplete="off"
              disabled={!props.edit}
              defaultValue={props.details.parentsEmail1}
              onChange={(e) => {
                emailRegex.test(e.target.value) && setPEmail1(e.target.value);
              }}
            />
          </div>
        </Grid.Column>
        <Grid.Column mobile={16} tablet={8} computer={8}>
          <div className="form-group">
            <label htmlFor="email2">Parent Email #2</label>
            <input
              id="email2"
              type="email"
              autoComplete="off"
              disabled={!props.edit}
              defaultValue={props.details.parentsEmail2}
              onChange={(e) => {
                emailRegex.test(e.target.value) && setPEmail2(e.target.value);
              }}
            />
          </div>
        </Grid.Column>
        <Grid.Column mobile={16} tablet={8} computer={8}>
          <div className="form-group">
            <label htmlFor="email2">Mother's Name</label>
            <input
              id="email2"
              type="email"
              autoComplete="off"
              disabled={!props.edit}
              defaultValue={props.details.motherName}
              onChange={(e) => setMother(e.target.value)}
            />
          </div>
        </Grid.Column>
        <Grid.Column mobile={16} tablet={8} computer={8}>
          <div className="form-group">
            <label htmlFor="email2">Father's Name</label>
            <input
              id="email2"
              type="email"
              autoComplete="off"
              disabled={!props.edit}
              defaultValue={props.details.fatherName}
              onChange={(e) => setFather(e.target.value)}
            />
          </div>
        </Grid.Column>
        <Grid.Column mobile={16} tablet={8} computer={8}>
          <div className="form-group">
            <label htmlFor="aname">CSA's Advocates Name</label>
            <AdvocatesDropdown
              className="cu-form-groups-dropdown"
              name="advocatesDropdown"
              onChange={(not, { value }) => {
                setAdvocate(value);
              }}
              disabled={!props.edit}
              placeholder={props.advocate}
            />
          </div>
        </Grid.Column>
        <Grid.Column mobile={16} tablet={8} computer={8}>
          <div className="form-group">
            <label htmlFor="pnumber1">Parent #1 Phone Number</label>
            <input
              id="pnumber1"
              type="text"
              autoComplete="off"
              disabled={!props.edit}
              defaultValue={props.details.parentsPhone1}
              onChange={(e) => {
                if (e.target.value && phoneRegex.test(e.target.value)) {
                  setPNum1(e.target.value);
                }
              }}
            />
          </div>
        </Grid.Column>
        <Grid.Column mobile={16} tablet={8} computer={8}>
          <div className="form-group">
            <label htmlFor="pnumber2">Parent #2 Phone Number</label>
            <input
              id="pnumber2"
              type="text"
              autoComplete="off"
              disabled={!props.edit}
              defaultValue={props.details.parentsPhone2}
              onChange={(e) => {
                if (e.target.value && phoneRegex.test(e.target.value)) {
                  setPNum2(e.target.value);
                }
              }}
            />
          </div>
        </Grid.Column>
        <Grid.Column mobile={16} tablet={8} computer={8}>
          <div className="form-group">
            <label htmlFor="spnumber">Student Athletes Phone Number </label>
            <input
              id="spnumber"
              type="text"
              autoComplete="off"
              disabled={!props.edit}
              defaultValue={props.details.athletesPhone}
              onChange={(e) => {
                if (e.target.value && phoneRegex.test(e.target.value)) {
                  setAthleteNumber(e.target.value);
                }
              }}
            />
          </div>
        </Grid.Column>
        <Grid.Column mobile={16} tablet={16} computer={16}>
          <div className="form-group">
            <label htmlFor="city">High School Name, City / State </label>
            <input
              id="city"
              type="text"
              autoComplete="off"
              disabled={!props.edit}
              defaultValue={props.details.school}
              onChange={(e) => setSchool(e.target.value)}
            />
          </div>
        </Grid.Column>
        <Grid.Column mobile={16} tablet={16} computer={16}>
          <div className="form-group">
            <label htmlFor="comments">Other thoughts or comments </label>
            <input
              id="comments"
              type="text"
              autoComplete="off"
              disabled={!props.edit}
              defaultValue={props.details.comment}
              onChange={(e) => setComment(e.target.value)}
            />
          </div>
        </Grid.Column>
        <Grid.Column mobile={16} tablet={16} computer={16}>
          <div className="form-group">
            <label htmlFor="comments1">
              Were you referred by someone specific if so, please state their
              name!
            </label>
            <input
              id="comments1"
              type="text"
              autoComplete="off"
              disabled={!props.edit}
              defaultValue={props.details.ref}
              onChange={(e) => setRef(e.target.value)}
            />
          </div>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

export default EditUserDetails;
